export const getDeadline = (
  deadline: number,
  onlyMonth: boolean = false,
): string => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth(); // Текущий месяц (от 0 до 11)
  const currentDay = currentDate.getDate();

  const nextMonth = (currentMonth + 1) % 12; // Следующий месяц

  const monthNames = [
    "января",
    "февраля",
    "марта",
    "апреля",
    "мая",
    "июня",
    "июля",
    "августа",
    "сентября",
    "октября",
    "ноября",
    "декабря",
  ];

  let message;

  if (currentDay > deadline) {
    const deadlineDate = new Date(
      currentDate.getFullYear(),
      nextMonth,
      deadline,
    );
    message = onlyMonth
      ? monthNames[nextMonth]
      : `${deadlineDate.getDate()} ${monthNames[nextMonth]} `;
  } else {
    const deadlineDate = new Date(
      currentDate.getFullYear(),
      currentMonth,
      deadline,
    );
    message = onlyMonth
      ? monthNames[currentMonth]
      : `${deadlineDate.getDate()} ${monthNames[currentMonth]} `;
  }

  return message;
};
